import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Bookmark } from 'lucide-react';
import { api } from '../lib/api';
import { PatientHeader } from './PatientLayout';
import { ContentRow, type ContentSummary } from './ContentListPage';
import { EmptyState, ErrorState, Spinner } from '../components/ui';

export function SavedPage() {
  const { slug } = useParams<{ slug: string }>();

  const saved = useQuery({
    queryKey: ['me', 'saved'],
    queryFn: () => api.get<{ items: Array<ContentSummary & { savedAt: string }> }>('/me/saved'),
  });

  if (saved.isError) return <ErrorState error={saved.error} onRetry={() => saved.refetch()} />;
  if (saved.isLoading || !saved.data) return <Spinner />;

  const items = saved.data!.items;

  return (
    <div className="max-w-lg lg:max-w-3xl mx-auto">
      <PatientHeader title="Guardados" subtitle="Lo que marcaste para volver a leer" />

      <div className="px-5 py-5">
        {items.length === 0 ? (
          <EmptyState
            icon={<Bookmark className="size-8" />}
            title="Todavía no guardaste nada"
            description="Cuando leas algo que te sirva, tocá el marcador para encontrarlo rápido después."
          />
        ) : (
          <div className="space-y-3">
            {items.map((item) => (
              <ContentRow
                key={item.id}
                item={{ ...item, saved: true }}
                to={`/${slug}/app/contenidos/${item.slug}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
